import { Printer } from '@ionic-native/printer';
import { Geolocation } from '@ionic-native/geolocation';
import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from "@agm/js-marker-clusterer";
import { Vibration } from '@ionic-native/vibration';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HTTP } from '@ionic-native/http';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import { MyApp } from './app.component';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AuthServiceProvider } from '../providers/auth-service/auth-service';
import { Network } from '@ionic-native/network';
import { FormsModule } from '@angular/forms';
import { Dialogs } from '@ionic-native/dialogs';
import { Toast } from '@ionic-native/toast';
import { SyncServerServiceProvider } from '../providers/sync-server-service/sync-server-service';
import { DistillingService } from '../providers/distilling-service/distilling-service';
import { SpecScopeProvider } from '../providers/spec-scope-service/spec-scope.service';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { Keyboard } from '@ionic-native/keyboard';
import { Device } from '@ionic-native/device';
import { ENV } from '@app/env'
import { StubService } from '../providers/stub-service/stub.service';
import { AppConfigProvider } from '../providers/app-config-service/app-config.service';
import { EnvService } from '../providers/env-friendly-service/env-friendly-service';
import { PermissionsService } from '../providers/permissions-service/permissions-service';
import { Diagnostic } from '@ionic-native/diagnostic';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CreateFormDetailsModule } from '../pages/modal-create-form/modal-create-form.module';
import { FilterFormsModule } from '../pages/forms/forms-filter.module';
import { SharedDirectivesModule } from '../directives/shared-directive.module';
import { Utility } from '../providers/util-service/util-service';
import { DistrictScopeProvider } from '../providers/district-scope-service/district-scope.service';
import { LabDefaultService } from '../providers/lab-default-service/lab-default-service';
import { Luxon } from '../providers/datetime-service/datetime-service';

@NgModule({
    declarations: [
        MyApp
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp),
        HttpClientModule,
        FormsModule,
        AgmCoreModule.forRoot({
            apiKey: ENV.GOOGLE_MAP_API_KEY
        }),
        CreateFormDetailsModule,
        FilterFormsModule
    ],
    exports:[
        AgmJsMarkerClustererModule,
        SharedDirectivesModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp
    ],
    providers: [
        StatusBar,
        SplashScreen,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        AuthServiceProvider,
        Network,
        HTTP,
        BarcodeScanner,
        Vibration,
        Geolocation,
        Dialogs,
        Toast,
        SyncServerServiceProvider,
        DistillingService,
        SpecScopeProvider,
        StubService,
        AppConfigProvider,
        EnvService,
        ScreenOrientation,
        Printer,
        Keyboard,
        Device,
        Diagnostic,
        InAppBrowser,
        PermissionsService,
        Utility,
        DistrictScopeProvider,
        LabDefaultService,
        Luxon
    ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts